// 试剂管理路由
import Layout from '@/layout'

const reagentRoute = [
    {
        path: '/reagent',
        component: Layout,
        redirect: '/reagent/reagentList',
        name: 'reagent',
        alwaysShow: true, // will always show the root menu
        meta: {
          title: '试剂管理',
          icon: 'huaxueshiji-',
          roles: ['ROLE_STAFF']
        },
        children: [
          {
            path: 'reagentList',
            component: () => import('@/views/reagent/reagentList'),
            name: 'reagentList',
            meta: {
              title: '常规试剂',
              icon: 'icon-test'
            }
          },
          {
            path: 'referenceMaterialList',
            component: () => import('@/views/reagent/referenceMaterialList'),
            name: 'referenceMaterialList',
            meta: {
              title: '标准物质',
              icon: 'icon-standard'
            }
          },
          {
            path: 'materialVerificationRecord',
            component: () => import('@/views/reagent/materialVerificationRecord'),
            name: 'materialVerificationRecord',
            meta: {
              title: '标准物质期间核查【查看】',
              icon: 'icon-standard'
            }
          },
          {
            path: 'material-verification',
            component: () => import('@/views/process/materialVerification/index'),
            name: 'materialVerification',
            meta: {
              title: '标准物质期间核查【申请】',
              icon: 'shouye'
            }
          },
          {
            path: "annual-reference-center",
            component: () => import("@/views/taskCenter/referenceMaterialCenter/index"),
            name: "referenceMaterialCenter",
            meta: {
              title: "标准物质期间核查【审批】",
              icon: "check-result",
            },
          }, 
          {
            path: 'referenceMaterialAdd/:id',
            component: () => import('@/views/reagent/referenceMaterialAdd'),
            name: 'referenceMaterialAdd',
            meta: {
              title: '标准物质添加',
              icon: 'user'
            },
            hidden: true
          },
          {
            path: 'referenceMaterialAdd',
            name: 'referenceMaterialEdit',
            component: () => import('@/views/reagent/referenceMaterialAdd'),
            meta: {
              title: '标准物质编辑',
              icon: 'usert'
            },
            hidden: true
          },
          {
          path: 'view-material-verification/:id',
          component: () => import('@/views/process/materialVerification/index'),
          name: 'viewMaterialVerification',
          meta: {
            title: '查看-标准物质的期间核查',
            icon: 'shouye'
          },
          hidden: true
        },
        {
          path: 'approval-material-verification/:id',
          component: () => import('@/views/process/materialVerification/index'),
          name: 'approvalMaterialVerification',
          meta: {
            title: '审核-标准物质的期间核查',
            icon: 'shouye'
          },
          hidden: true
        },
        ]
      }
];

export default reagentRoute


// WEBPACK FOOTER //
// ./src/router/modules/reagent.js